import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, PageEvent } from '@angular/material';
import { Router } from '@angular/router';

import { Fornecedor } from '../../models/fornecedor';
import { FechamentoFinanceiro } from '../../models/fechamento-financeiro';
import { TipoArquivo } from '../../models/enum';

import { FechamentoFinanceiroService } from '../../services/fechamento-financeiro.service';
import { FornecedorService } from '../../services/fornecedor.service';
import { CarregandoService } from '../../services/carregando.service';
import { NotificacaoService } from '../../services/notificacao.service';

import { PedidosFechamentoComponent } from '../../modals/pedidos-fechamento/pedidos-fechamento.component';
import { SelecionarStatusFechamentoComponent } from 'src/app/modals/selecionar-status-fechamento/selecionar-status-fechamento.component';
import { ArquivoService } from 'src/app/services/arquivo.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { ProdutoFechamentoModalComponent } from 'src/app/modals/produto-fechamento-modal/produto-fechamento-modal.component';
import { PremissasService } from 'src/app/services/premissas.service';
import { GlobalService } from 'src/app/services/global.service';

declare const $: any;
@Component({
  selector: 'app-consulta-fechamento-financeiro',
  templateUrl: './consulta-fechamento-financeiro.component.html',
  styleUrls: ['./consulta-fechamento-financeiro.component.scss']
})
export class ConsultaFechamentoFinanceiroComponent implements OnInit {
  fornecedores: Fornecedor[] = [];
  fechamentos: FechamentoFinanceiro[] = [];
  periodos = [
    { id: 0, name: 'Todos' },
    { id: 1, name: 'Mês Atual' },
    { id: 2, name: 'Mês Passado' },
    { id: 3, name: 'Personalizado' },
    { id: 4, name: 'Hoje' },
    { id: 5, name: 'Ontem' },
    { id: 6, name: 'Semana' },
    { id: 7, name: 'Últimos 3 Meses' },
    { id: 8, name: 'Últimos 6 Meses' },
    { id: 9, name: 'Ano Atual' }
  ];

  enumStatus = [
    { id: 0, name: 'Em análise' },
    { id: 1, name: 'Aprovado' },
    { id: 2, name: 'Reprovado' },
  ];

  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };
  listaDeItensPorPagina = [];

  filtroConsultaFechamento = {
    periodoSelecionado: 0,
    fornecedorSelecionado: undefined,
    campoOrdenacao: 'idFechamento',
    ordenarDesc: false,
    itensPorPagina: 10,
    statusSelecionados: [],
    pInicio: undefined,
    pFim: undefined,
  };

  verExcel = false;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private globalService: GlobalService,
    private fornecedorService: FornecedorService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private fechamentoFinanceiroService: FechamentoFinanceiroService,
    public dialog: MatDialog,
    private router: Router,
    private arquivoService: ArquivoService,
    private utilitarioService: UtilitarioService,
    private premissasService: PremissasService
  ) { }

  async ngOnInit() {

    this.carregandoService.mostra('consultarMultiFornecedores');
    this.premissasService.consultarMultiFornecedores().subscribe(f => {
      if (!f.valor) {
        this.router.navigate(['/']);
      } else {
        this.buscarFornecedores();

        if (localStorage.getItem('filtroConsultaFechamento') !== null) {
          this.filtroConsultaFechamento = JSON.parse(localStorage.getItem('filtroConsultaFechamento'));

          this.filtroConsultaFechamento.pInicio = new Date(this.filtroConsultaFechamento.pInicio);
          this.filtroConsultaFechamento.pFim = new Date(this.filtroConsultaFechamento.pFim);
          this.buscarFechamentos();
        }
      }
      this.carregandoService.esconde('consultarMultiFornecedores');
    }, (erro) => {
      this.carregandoService.esconde('consultarMultiFornecedores');
      this.notificacaoService.erro(erro);
    });

    this.verExcel = (await this.globalService.consultaUsuario()).verExcel;
  }

  retornaClasseStatus(status: number) {
    switch (status.toString()) {
      case '0':
        return 'badge-info';
      case '1':
        return 'badge-success';
      case '2':
        return 'badge-danger';

      default:
        return 'badge-info';
    }
  }

  definePeriodo() {
    if (this.filtroConsultaFechamento.periodoSelecionado !== 3) {
      this.filtroConsultaFechamento.pInicio = undefined;
      this.filtroConsultaFechamento.pFim = undefined;

      this.buscarFechamentos();
      return;
    }

    if (!!this.filtroConsultaFechamento.pInicio && !!this.filtroConsultaFechamento.pFim) {
      this.buscarFechamentos();
    }
  }

  buscarFornecedores() {
    this.carregandoService.mostra('buscarFornecedores');

    this.fornecedorService.consultarFornecedores().subscribe(
      (forn) => {
        this.fornecedores = forn;
        this.carregandoService.esconde('buscarFornecedores');
      },
      (err) => {
        this.carregandoService.esconde('buscarFornecedores');
        this.notificacaoService.erro(err);
      }
    );
  }

  ordena(campo: string) {
    if (campo) {
      this.filtroConsultaFechamento.campoOrdenacao = campo;
      this.filtroConsultaFechamento.ordenarDesc = !this.filtroConsultaFechamento.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  mudaDePagina(pageEvent: PageEvent) {
    this.filtroConsultaFechamento.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarFechamentos();
  }

  buscarFechamentos() {
    this.carregandoService.mostra('buscarFechamentos');

    localStorage.setItem('filtroConsultaFechamento', JSON.stringify(this.filtroConsultaFechamento));

    this.fechamentoFinanceiroService.consultarFechamentosComPaginacao(
      this.filtroConsultaFechamento.periodoSelecionado,
      this.filtroConsultaFechamento.statusSelecionados,
      this.paginacao.paginaAtual,
      this.filtroConsultaFechamento.itensPorPagina,
      this.filtroConsultaFechamento.campoOrdenacao,
      this.filtroConsultaFechamento.ordenarDesc,
      this.filtroConsultaFechamento.fornecedorSelecionado,
      this.filtroConsultaFechamento.pInicio,
      this.filtroConsultaFechamento.pFim
    ).subscribe(
      (res: { itens: FechamentoFinanceiro[], total: number }) => {
        this.fechamentos = res.itens;
        this.paginacao.total = res.total;
        this.carregandoService.esconde('buscarFechamentos');
      },
      (err: Error) => {
        this.carregandoService.esconde('buscarFechamentos');
        this.notificacaoService.erro(err);
      }
    );
  }

  abrirPedidos(fechamento: FechamentoFinanceiro) {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(PedidosFechamentoComponent, {
      width: largura > 1150 ? '1100px' : (($('body').width()).toString() + 'px'),
      data: { idFechamento: fechamento.id },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  alterarStatus(fechamento: FechamentoFinanceiro) {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(SelecionarStatusFechamentoComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: {
        idFechamento: fechamento.id,
        idStatus: fechamento.status,
        valorFechamento: fechamento.valor
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(() => {
      this.buscarFechamentos();
    });
  }

  editarFechamento(idFechamento: number) {
    this.router.navigate(['fechamento-financeiro/editar', idFechamento]);
  }

  mostrarPreview(fechamento: FechamentoFinanceiro) {
    this.carregandoService.mostra('mostrarPreview');
    this.arquivoService.baixarArquivo(fechamento.id, TipoArquivo.Fechamento).subscribe(arq => {

      if (this.utilitarioService.ePDF(fechamento.arquivo)) {
        this.utilitarioService.openBlobModal(arq, fechamento.arquivo);
      } else if (this.utilitarioService.eImagem(fechamento.arquivo)) {
        this.utilitarioService.mostrarImagemBlob(arq, fechamento.arquivo);
      } else {
        this.utilitarioService.saveBlob(arq, fechamento.arquivo);
      }

      this.carregandoService.esconde('mostrarPreview');
    }, (erro) => {
      this.carregandoService.esconde('mostrarPreview');
      this.notificacaoService.erro(erro);
    });
  }

  abrirListaDeProdutos(fechamento: FechamentoFinanceiro) {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(ProdutoFechamentoModalComponent, {
      width: largura > 1150 ? '1100px' : (($('body').width()).toString() + 'px'),
      data: { idFechamento: fechamento.id },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  exportar() {
    this.carregandoService.mostra('exportar');
    this.fechamentoFinanceiroService.exportarConsultaFechamento(
      this.filtroConsultaFechamento.periodoSelecionado,
      this.filtroConsultaFechamento.statusSelecionados,
      this.paginacao.paginaAtual,
      this.filtroConsultaFechamento.itensPorPagina,
      this.filtroConsultaFechamento.campoOrdenacao,
      this.filtroConsultaFechamento.ordenarDesc,
      this.filtroConsultaFechamento.fornecedorSelecionado,
      this.filtroConsultaFechamento.pInicio,
      this.filtroConsultaFechamento.pFim
    ).subscribe(
      (arq) => {
        this.utilitarioService.saveBlob(arq, 'FechamentosConsulta.xlsx');
        this.carregandoService.esconde('exportar');
      },
      (err) => {
        this.carregandoService.esconde('exportar');
        this.notificacaoService.erro(err);
      }
    );
  }
}
